import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";

function AdminRoleJustificatifsPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {roleName} = useParams();
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [role, setRole] = useState({});
    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/roles/${roleName}/justificatifs`);
                const parseData = response.data.myJustificatifs;
                setMyApiData(parseData);
                setRole(response.data.myRole);

            } catch (error) {
                console.error('error', error);
            }
        })();
    }, [user]);
    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ role }));
    }, [role]);


    const list = myApiData.map((j, index) => {
        return (
            <li key={index}>
                <Link to={j?.justId?.toString()}>{j.justLabel}</Link>
            </li>
        )
    });

    return (
        <div className="content">
            <TitleMain text="Justificatifs"/>

            <ul>
                {list}
            </ul>

        </div>
    )
}

export default AdminRoleJustificatifsPage;
